import { Box, Spinner } from "@chakra-ui/react";
import React from "react";

export default React.memo(function SnapshotAnimation({ in: inProp, onEnd }) {
  const [status, setStatus] = React.useState("resting");

  React.useEffect(() => {
    if (inProp && status === "resting") {
      setStatus("entering");
      return;
    }
    if (!inProp && status === "loading") {
      setStatus("exiting");
      return;
    }
  }, [inProp, status]);

  function onTransitionEnd() {
    if (status === "entering" && !inProp) {
      setStatus("exiting");
      return;
    }
    if (status === "entering") {
      setStatus("loading");
      return;
    }
    if (status === "exiting") {
      setStatus("resting");
      onEnd && onEnd();
    }
  }

  const translateIn = status === "entering" || status === "loading";

  return (
    <>
      <Box
        onTransitionEnd={onTransitionEnd}
        background="black"
        width="100vw"
        height="50vh"
        position="fixed"
        top="0"
        left="0"
        transform={`translateY(${translateIn ? "0px" : "-51vh"})`}
        transition="all 200ms ease-in-out"
      />
      <Box
        background="black"
        width="100vw"
        height="50vh"
        position="fixed"
        bottom="0"
        left="0"
        transform={`translateY(${translateIn ? "0px" : "51vh"})`}
        transition="all 200ms ease-in-out"
      />
      {status === "loading" && (
        <Box
          position="fixed"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
        >
          <Spinner color="white" />
        </Box>
      )}
    </>
  );
});
